$(document).on("turbolinks:load", () => {
  if ($('.media-hider-labels').length > 0) {
    $('.media-hider-labels').each(function() {
      return $(this).closest('.form-group').find('.media-hider-fields').hide();
    });
  }

  $('form').on('click', '.replace-media', function(e) {
    var mediaFields, mediaLabels;
    e.preventDefault();
    mediaLabels = $(this).closest('.media-hider-labels');
    mediaFields = $(this).closest('.form-group').find('.media-hider-fields');
    mediaLabels.hide();
    return mediaFields.show();
  });
})
